import { func, shape, arrayOf } from 'prop-types';
import { object } from 'yup';
import { Form, Field } from 'react-final-form';
import Message from '../Forms/message';
import Select from '../Forms/select';
import { InputWrapper, FormSection, SectionLabel, Content, ButtonsWrapper } from '../Forms/common';
import { validateFormValues } from '../Forms/formValidation';
import Button from '../StoraEnsoComponents/Button';

const validationSchema = object({
  location: object()
    .nullable(true)
    .required('Location is required'),
  user: object()
    .nullable(true)
    .required('User is required')
});

function AddUserLocationForm({
  locationValues,
  userValues,
  handleFormSubmit,
}) {
  return (
    <Form
      onSubmit={handleFormSubmit}
      validate={validateFormValues({
        schema: validationSchema
      })}
      initialValues={{
        location: null,
        user: null,
      }}
      render={({ handleSubmit }) => (
        <FormSection>
          <SectionLabel>Add user to location</SectionLabel>
          <Content>

            <Field name="location">
              {({ input, meta }) => (
                <InputWrapper>
                  <label>Type</label>

                  <Select
                    id="location"
                    options={locationValues}
                    placeholder="Select location"
                    {...input}
                    {...meta}
                    onChange={value => {
                      input.onChange(value);
                    }}
                  />
                  {
                    meta.touched && meta.error && (
                      <Message isError>{meta.error}</Message>
                    )
                  }
                </InputWrapper>
              )}
            </Field>

            <Field name="user">
              {({ input, meta }) => (
                <InputWrapper>
                  <label>User</label>

                  <Select
                    id="type"
                    options={userValues}
                    placeholder="Select user"
                    {...input}
                    {...meta}
                    onChange={value => {
                      input.onChange(value);
                    }}
                  />
                  {
                    meta.touched && meta.error && (
                      <Message isError>{meta.error}</Message>
                    )
                  }
                </InputWrapper>
              )}
            </Field>

            <ButtonsWrapper>
              <Button type="submit" onClick={handleSubmit}>
                Add user location
              </Button>
            </ButtonsWrapper>
          </Content>
        </FormSection>
      )}
    />
  );
}

AddUserLocationForm.propTypes = {
  locationValues: arrayOf(shape({})).isRequired,
  userValues: arrayOf(shape({})).isRequired,
  handleFormSubmit: func.isRequired,
}

export default AddUserLocationForm;